<script setup>
// import i18n from "@/i18n"
import {
    defineProps, defineEmits, inject,
    computed,
    ref

} from "vue";
import Swal from "sweetalert2";
import { useRoute } from "vue-router";
import copySvg from "@/assets/images/svg/copy.svg"
import { getLangValue,getLangValueByKey } from "@/utils/common"; //获取后端语言
const props = defineProps({
    customFieldsList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const isCheckForm = inject('isCheckForm')
const route = useRoute()
const emits = defineEmits(["update:customFieldsList"])
const customFieldsList = ref(computed(() => props.customFieldsList))
const currentTabLang = inject('currentTabLang') //切换语言

//方法
const handler = (type, i = "", item) => {
    // console.log(i);
    switch (type) {
        case "copy": {
            let item1 = JSON.parse(JSON.stringify(item))
            // 修改id
            item1.id = item.id ? `${item.id}${customFieldsList.value.length + 1}` : `cusText${customFieldsList.value.length + 1}`
            item1.key = item.key ? `${item.key}${customFieldsList.value.length + 1}` : `cusText${customFieldsList.value.length + 1}`
            let new_customFieldsList = [
                ...customFieldsList.value.slice(0, i + 1),
                item1,
                ...customFieldsList.value.slice(i + 1),
            ];
            console.log(new_customFieldsList);
            emits('update:customFieldsList', new_customFieldsList)
            break;
        }
        case "delete": {
            Swal.fire({
                title: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_title"): getLangValueByKey("base.delete_alert_title", 'en'),
                text: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_info"): getLangValueByKey("base.delete_alert_info", 'en'),
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
                cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
            }).then(async (result) => {
                if (result.isConfirmed) {
                    customFieldsList.value.splice(i, 1)
                    emits('update:customFieldsList', customFieldsList.value)
                }
            });

            break;
        }
        default:
            break;
    }
}

const changeName = () => {
    emits('update:customFieldsList', customFieldsList.value)
}
const handlerSwitch = () => {
    console.log(customFieldsList.value);
    emits('update:customFieldsList', customFieldsList.value)
}

// watch(customFieldsList, (val) => {
//     console.log(val);
// }, { deep: true })

</script>
<template>
    <template v-for="(item, index) in customFieldsList" :key="index">
        <b-card v-show="route.query.type != 'view' || (route.query.type == 'view' && item.isShow)">
            <div class="row gy-3 w-100">
                <div class="d-flex justify-content-between align-items-center  pb-2"
                    style="font-weight: bold;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                    <div>
                        <input v-show="currentTabLang == 1" @change="changeName" :disabled="route.query.type == 'view'"
                            type="text" class="form-control" v-model="item.name" style="min-width: 300px;"
                            :placeholder="getLangValue('product-template.text')"
                            :class="[(isCheckForm && !item.name) && 'is-invalid']" />
                        <input v-show="currentTabLang == 2" @change="changeName" :disabled="route.query.type == 'view'"
                            type="text" class="form-control" v-model="item.name_en" style="min-width: 300px;"
                            :placeholder="getLangValue('product-template.text')"
                            :class="[(isCheckForm && !item.name_en) && 'is-invalid']" />
                    </div>
                    <div style="width: 135px;" class="d-flex align-items-center justify-content-between"
                        v-if="route.query.type != 'view'">
                        <div class="form-check form-switch form-switch-success">
                            <input class="form-check-input" v-model="item.isShow" @change="handlerSwitch"
                                type="checkbox" role="switch" id="SwitchCheck3" checked>
                        </div>
                        <img v-if="!item.hideCopy" class="cursor-pointer" :src="copySvg"
                            @click="handler('copy', index, item)" style="width: 24px;" />
                        <i @click="handler('delete', index)" style="color:#ED5E5E"
                            v-show="item.showDelete && route.query.type != 'view'"
                            class=" cursor-pointer ri-delete-bin-5-fill me-1 align-bottom"></i>
                    </div>
                </div>
                <!-- 字段部分 -->
                <div class="row  d-flex justify-content-start">
                    <textarea class="form-control" disabled id="exampleFormControlTextarea5" rows="3"></textarea>
                </div>
            </div>
        </b-card>
    </template>
</template>
<style></style>